import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import PendingApproval from './PendingApproval';

/**
 * Gate for the customer surface (Access Control Phase 1). Replaces a plain
 * RoleGuard so that a logged-in-but-unapproved user sees a useful next step
 * instead of being bounced to the landing page.
 *
 *   - admins bypass (preview)
 *   - suspended                  -> PendingApproval (dead-end: contact us)
 *   - not-yet-active (pending)   -> the app in preview mode: market + price check open
 *                                   (access_features.open_to_pending), brand verification at
 *                                   /customer/connect unlocks the rest
 *   - active                     -> the customer app (tabs are feature-gated inside)
 */
export function CustomerGate({ children }: { children: ReactNode }) {
  const { user, role, accessStatus, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (role === 'admin') return <>{children}</>;
  // Race guard: role still resolving.
  if (role === 'public') return null;
  if (accessStatus === 'suspended') return <PendingApproval />;
  return <>{children}</>;
}
